import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventCategoryState }  from 'Redux/Slices/EventCategory/EventCategorySlice';
import { EventCategory }        from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findEventCategoryRequest = (state: Draft<IEventCategoryState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEventCategorySuccess = (state: Draft<IEventCategoryState>, { type, payload }: PayloadAction<{
  eventCategory: EventCategory
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.eventCategory.id]: payload.eventCategory };
};

export const findEventCategoryFailure = (state: Draft<IEventCategoryState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
